import React from 'react';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import PublicIcon from '@mui/icons-material/Public';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StoreIcon from '@mui/icons-material/Store';
import GroupsIcon from '@mui/icons-material/Groups';
import IsometricShowcase from '../IsometricShowcase/IsometricShowcase';
import styles from './LandingPageV4.module.css';

const platformCapabilities = [
  {
    id: 'operations',
    label: 'Connected retail suite',
    mobileLabel: 'One retail suite',
    detail: 'POS, inventory, and online ordering',
    icon: StoreIcon,
  },
  {
    id: 'commerce',
    label: 'Every channel connected',
    mobileLabel: 'All channels',
    detail: 'Storefront, pickup, and delivery',
    icon: PublicIcon,
  },
];

const ContentBottom = () => (
  <section
    id="for-merchants"
    className={styles.partnerSection}
    aria-labelledby="partner-title"
  >
    <div className={styles.innerWrapper}>
      <div className={styles.partnerCard}>
        <div className={styles.partnerCardContent}>
          <p className={styles.partnerEyebrow}>Built for independent retailers</p>
          <h2 id="partner-title" className={styles.partnerTitle}>
            One store. Every channel. Finally in sync.
          </h2>
          <p className={styles.partnerDescription}>
            Run the counter, inventory, online orders, pickup, and delivery from
            one connected retail system.
          </p>
          <ul className={styles.partnerFeatureList}>
            <li>
              <StoreIcon sx={{ fontSize: 17 }} aria-hidden="true" />
              POS + inventory
            </li>
            <li>
              <DashboardIcon sx={{ fontSize: 17 }} aria-hidden="true" />
              Online ordering
            </li>
            <li>
              <GroupsIcon sx={{ fontSize: 17 }} aria-hidden="true" />
              Pickup + delivery
            </li>
          </ul>
          <a
            href="https://merchants.quickvee.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.partnerGlassBtn}
          >
            Explore Quickvee for retailers
            <NorthEastIcon sx={{ fontSize: 18 }} aria-hidden="true" />
          </a>
        </div>

        <div className={styles.partnerExperience}>
          <div className={styles.partnerPlatformHalo} aria-hidden="true" />
          <p className={styles.partnerPlatformKicker}>
            <span className={styles.partnerPlatformPulse} aria-hidden="true" />
            <span className={styles.partnerPlatformKickerLabel}>
              Quickvee retail suite
            </span>
          </p>

          <IsometricShowcase
            className={styles.partnerShowcase}
            background="transparent"
          />

          <ol
            className={styles.partnerViewTimeline}
            aria-label="Quickvee retail suite capabilities"
          >
            {platformCapabilities.map((view) => {
              const ViewIcon = view.icon;

              return (
                <li key={view.id} className={styles.partnerViewTimelineItem}>
                  <span className={styles.partnerViewTimelineIcon}>
                    <ViewIcon sx={{ fontSize: 16 }} aria-hidden="true" />
                  </span>
                  <span className={styles.partnerViewTimelineCopy}>
                    <strong>
                      <span className={styles.partnerViewLabelFull}>
                        {view.label}
                      </span>
                      <span className={styles.partnerViewLabelCompact}>
                        {view.mobileLabel}
                      </span>
                    </strong>
                    <small>{view.detail}</small>
                  </span>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default ContentBottom;
